// extracted by mini-css-extract-plugin
export var picture = "index-module--picture--2zsMU";